export default __webpack_public_path__ + "static/media/detail_big_14_4.1e0c2a83.jpg";